import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetInquiryDetailMutation, useUpdInquiryMutation } from "../../../../../store/admin/adminInquiryApiSlice";
import Moment from "react-moment";

export const ViewInquiry = () => {
    const {contentsId}:any = useParams()
    const navigate = useNavigate();
    const [data, setData] = useState<any>([ ])
    const [getInquiryDetailApi] = useGetInquiryDetailMutation()
    // 답변 상태 변경
    const [updInquiryApi] = useUpdInquiryMutation()
    const getDetail = async() => {
        const result : any = await getInquiryDetailApi({idx : contentsId})
        if(result.data.result === true){setData(result.data)}
    }
    const handleChangeStatus = async() => {
        const replyStatus = data?.reply_status === '답변전'?'답변완료':'답변전';
        const confirm = window.confirm(`${replyStatus} 상태로 변경하시겠습니까?`);
        const formData = new FormData()
        formData.append('inquiry_idx', contentsId)
        formData.append('reply_status', replyStatus)
        if(confirm){
            const result : any = await updInquiryApi(formData)
            if(result.data.result === true){navigate(-1)}
        }
    }
    useEffect(()=>{getDetail()}, [])
    return(
        <>
        <div className="contentBox inquiryView">
            <h3>Inquiry</h3>
            <div className="flexWrap">
                <h4>Inquiry View</h4>
                
                <div>
                    <button className="blackBtn" onClick={()=>navigate(-1)}>목록으로</button>
                    <button className="blueBtn" onClick={handleChangeStatus}>{data?.reply_status === '답변전'?'답변완료':'답변전'}</button>
                </div>
            </div>
            
            <div className="content">
                <div className="titleBox">
                    <span className="answer_before">{data?.reply_status}</span>
                    <span className="answer_title">{data?.inquiry_title}</span>
                    <span className="date">
                        <Moment format="YYYY.MM.DD">{data?.inquiry_mdate}</Moment>
                    </span>
                </div>
                <ul>
                    <li>
                        <span>이름 : </span>
                        <span>{data?.inquiry_name}</span>
                    </li>
                    <li>
                        <span>이메일 : </span>
                        <span>{data?.inquiry_email}</span>
                    </li>
                    <li>
                        <span>국적 : </span>
                        <span>South Korea</span>
                    </li>
                </ul>

                <ul>
                    <li>
                        <span>문의유형</span>
                        <div>
                            <span>{data?.inquiry_type}</span>
                        </div>
                    </li>
                    <li>
                        <span>문의내용</span>
                        <div>
                            {data?.inquiry_contents}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        </>
    )
}